import makeStyles from "@material-ui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
    eventMeta: {
        marginBottom: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
    },
}));
